

import {
    Component,
    OnInit,
  } from "@angular/core";
  import { NGXLogger } from "ngx-logger";
  import { MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
  import * as Leaflet from "leaflet";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";

  

@Component({
    selector: "app-posizione-fase1",
    templateUrl: "./dialog-posizione.component.html",
    styleUrls: ["../fase1.bando1.component.css"],
  })
  export class DialogPosizionePraticaFase1 implements OnInit {
    protected _onDestroy = new Subject<void>();
    public pratica: PraticaFlowdy2_Firestore;
    protected positionHasChanged:boolean = false;
    
    protected map!: Leaflet.Map;
    protected markers: Leaflet.Marker[] = [];
    protected options = {
      layers: [
        Leaflet.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }),
      ],
      zoom: 15,
      center: { lat: 28.626137, lng: 79.821603 },
    };
  
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService
    ) {}
  
    ngOnInit(): void {
      this.pratica          = this.config.data.pratica;
     // this.praticaCompleta  = this.config.data.praticaCompleta;
    }
    initMarkers() {
        this.logger.info("*** initMarkers 1");
        this.logger.info(this.pratica.coordinateScuola.latitude.valueOf());
        this.logger.info(this.pratica.coordinateScuola.longitude.valueOf());
      const initialMarkers = [
        {
          position: {
            lat: this.pratica.coordinateScuola.latitude.valueOf(),
            lng: this.pratica.coordinateScuola.longitude.valueOf(),
          },
          draggable: false,
        },
      
      ];
      const dataScuola = initialMarkers[0];
      const markerScuola = this.generateMarker(dataScuola, 0, true);
      this.logger.info("*** initMarkers 2");
     let popupScuola = "SCUOLA <b> "+ this.pratica.denominazione + "</b><br>" +
                        this.pratica.indirizzo + "<br>"+
                        "<b>" + this.pratica.comune + "</b><br>";
       
                        this.logger.info("*** initMarkers 3");
      markerScuola.addTo(this.map).bindPopup(popupScuola);
      
      this.markers.push(markerScuola);
  
      
      this.map.panTo(dataScuola.position);
  
    }
  
    markerOver(event: any, index: number){
      const marker = event.target;
      marker.openPopup();
    }
    markerOut(event, index) {
      const marker = event.target;
      marker.closePopup();
    }
    generateMarker(data: any, index: number, isScuola:boolean) {
      let markerIconScuola = new Leaflet.Icon({
        iconUrl: '/assets/leaflet/images/marker-icon-bando2.png',
        //iconSize: [40, 25],
        iconSize: [25, 41],
      });
      let markerIconCentrale= new Leaflet.Icon({
        iconUrl: '/assets/leaflet/images/marker-icon-centrale.png',
      iconSize: [25, 41],
      });
      if(isScuola){
        return Leaflet.marker(data.position, { draggable: data.draggable, icon:markerIconScuola })
          //.on("click", (event) => this.markerClicked(event, index))
          .on("mouseover", (event) => this.markerOver(event, index))
          .on("mouseout", (event) => this.markerOut(event, index))
          .on("dragend", (event) => this.markerDragEnd(event, index));
      }else{
        return Leaflet.marker(data.position, { draggable: data.draggable, icon:markerIconCentrale })
       // .on("click", (event) => this.markerClicked(event, index))
        .on("mouseover", (event) => this.markerOver(event, index))
        .on("mouseout", (event) => this.markerOut(event, index))
        .on("dragend", (event) => this.markerDragEnd(event, index));
      }
      
    }
    markerClicked($event: any, index: number) {}
  
    markerDragEnd($event: any, index: number) {}
    onMapReady($event: Leaflet.Map) {
        this.logger.info("*** onMapReady");
      this.map = $event;
      this.initMarkers();
    }
  
    mapClicked($event: any) {}
  }